import apiClient from "../../authentication/utils/core/axios";

const PostEvidenceAPI = {

  // CREATE evidence
  createEvidence: async (payload) => {
    const res = await apiClient.post(`/evidence`, payload);
    if (res.status !== 201) throw new Error("Failed to create evidence");
    return res.data;
  },

  // GET /evidence/{id}
  getEvidence: async (evidenceId) => {
    const res = await apiClient.get(`/evidence/${evidenceId}`);
    if (res.status !== 200) throw new Error("Evidence not found");
    return res.data;
  },

  // GET /evidence list (filters)
  listEvidence: async (params) => {
    const res = await apiClient.get(`/evidence`, { params });
    if (res.status !== 200) throw new Error("Failed to fetch evidence list");
    return res.data; // {items, total, skip, limit}
  },

  // UPDATE PUT /evidence/{id}
  updateEvidence: async (evidenceId, payload) => {
    const res = await apiClient.put(`/evidence/${evidenceId}`, payload);
    if (res.status !== 200) throw new Error("Failed to update evidence");
    return res.data;
  },

  // DELETE /evidence/{id}
  deleteEvidence: async (evidenceId) => {
    const res = await apiClient.delete(`/evidence/${evidenceId}`);
    if (res.status !== 204) throw new Error("Failed to delete evidence");
    return { ok: true, evidenceId };
  },

  // FLAG evidence
  flagEvidence: async (payload) => {
    const res = await apiClient.post(`/evidence/flags`, payload);
    if (res.status !== 201) throw new Error("Failed to flag evidence");
    return res.data;
  },

  // GET flags for evidence
  getEvidenceFlags: async (evidenceId) => {
    const res = await apiClient.get(`/evidence/flags/${evidenceId}`);
    if (res.status !== 200) throw new Error("Failed to fetch evidence flags");
    return res.data;
  },

  // PATCH resolve flag
  resolveFlag: async (flagId, is_upheld) => {
    const res = await apiClient.patch(`/evidence/flags/${flagId}/resolve`, null, {
      params: { is_upheld }
    });
    if (res.status !== 200) throw new Error("Failed to resolve flag");
    return res.data;
  },

  // POST helpful
  toggleHelpful: async (evidenceId) => {
    const res = await apiClient.post(`/evidence/helpful/${evidenceId}`);
    if (res.status !== 200) throw new Error("Failed to toggle helpful vote");
    return res.data; // { evidence_id, is_helpful, helpful_count }
  },

  // GET helpful check
  checkHelpful: async (evidenceId) => {
    const res = await apiClient.get(`/evidence/helpful/check/${evidenceId}`);
    if (res.status !== 200) throw new Error("Failed to check helpful vote");
    return res.data;
  },

  // GET score for post
  getPostScore: async (postId) => {
    const res = await apiClient.get(`/evidence/score/post/${postId}`);
    if (res.status !== 200) throw new Error("Failed to fetch post evidence score");
    return res.data;
  },

  // GET user stats
  getUserEvidenceStats: async (userId) => {
    const res = await apiClient.get(`/evidence/stats/user/${userId}`);
    if (res.status !== 200) throw new Error("Failed to fetch user evidence stats");
    return res.data;
  },

  // GET post summary
  getPostEvidenceSummary: async (postId) => {
    const res = await apiClient.get(`/evidence/summary/post/${postId}`);
    if (res.status !== 200) throw new Error("Failed to fetch post evidence summary");
    return res.data;
  },

  // ADMIN: GET disputed evidence
  getDisputedEvidence: async (params) => {
    const res = await apiClient.get(`/evidence/admin/pending-review`, { params });
    if (res.status !== 200) throw new Error("Failed to fetch disputed evidence");
    return res.data;
  },

  // ADMIN: update status
  updateEvidenceStatusAdmin: async (evidenceId, new_status) => {
    const res = await apiClient.patch(`/evidence/admin/${evidenceId}/status`, null, {
      params: { new_status }
    });
    if (res.status !== 200) throw new Error("Failed to update evidence status");
    return res.data;
  },
};

export default PostEvidenceAPI;
